import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {createUrlWithPreselectedSize} from '../ProductUrl';

export const createSimilarProductsPageUrl = (product: Product) => {
  const [pathname = ''] = (product.path ?? '').split('?');
  const {pathname: targetRoutePathname} = createUrlWithPreselectedSize({
    pathname,
  });
  return targetRoutePathname + '/similar';
};
